import { ECommonRequestStatus } from './constants'
import type { IRequestResponse, IResponse } from './interfaces'

// @deprecated
export const isStatusOk = <T>(response?: IResponse<T>) => response?.meta.status === ECommonRequestStatus.OK

export const isSuccess = <T>(response?: IRequestResponse<T>) => response?.meta?.status === ECommonRequestStatus.OK
